module.exports = __webpack_public_path__ + "media/images/badges/circular-economies-100-85dad0d871621df1905a7d86c80bddf7.svg";